import { TFunction } from 'i18next';
import { KpiClassMetric, KpiTier } from '@/type/kpi-dashboard.types';
import { isSingularCount, KPI_TIER_COLORS } from '@/utils/kpi-dashboard.utils';

interface ClassRankingCardProps {
  t?: TFunction<undefined>;
  title: string;
  /** Tier driving the border, row tint and value colour of the ranking. */
  tier: KpiTier;
  icon: React.ReactNode;
  classes: KpiClassMetric[];
}

export const ClassRankingCard = ({
  t,
  title,
  tier,
  icon,
  classes,
}: ClassRankingCardProps) => {
  const tierColor = KPI_TIER_COLORS[tier];

  return (
    <div
      className="rounded-xl border bg-white p-5"
      style={{ borderColor: tierColor?.border }}
    >
      <div
        className="mb-4 flex items-center gap-2"
        style={{ color: tierColor?.text }}
      >
        {icon}
        <h3 className="text-sm font-semibold uppercase tracking-wider">
          {title}
        </h3>
      </div>
      <ol className="flex flex-col gap-2">
        {(classes ?? []).map((kpiClass, index) => (
          <li
            key={kpiClass?.id}
            className="flex items-center justify-between gap-3 rounded-lg px-3 py-2"
            style={{ background: tierColor?.soft }}
          >
            <div className="flex min-w-0 items-center gap-3">
              <span
                className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white"
                style={{ background: tierColor?.solid }}
              >
                {index + 1}
              </span>
              <div className="min-w-0">
                <p className="truncate text-sm font-medium text-black-071336">
                  {kpiClass?.name}
                </p>
                <p className="text-xs text-gray-78829D">
                  {t(
                    isSingularCount(kpiClass?.annotations ?? 0)
                      ? 'annotationCount'
                      : 'annotationsCount',
                    { value: kpiClass?.annotations ?? 0 },
                  )}
                </p>
              </div>
            </div>
            <span
              className="shrink-0 font-mono text-sm font-bold tabular-nums"
              style={{ color: tierColor?.text }}
            >
              {(kpiClass?.iou ?? 0).toFixed(3)}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
};
